
import { WebsiteSection, groupedSections } from './types/section-types';

interface SectionSelectProps {
  value: WebsiteSection;
  onChange: (value: WebsiteSection) => void;
}

export const SectionSelect = ({ value, onChange }: SectionSelectProps) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Bereich auswählen
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as WebsiteSection)}
        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 bg-white p-2"
      >
        <optgroup label="Hauptsektionen (NS1-NS8)">
          {groupedSections.mainSections.map(([value, label]) => (
            <option key={value} value={value}>{label as string}</option>
          ))}
        </optgroup>
        
        <optgroup label="Doppelklick NS2 (Deine Situation)">
          {groupedSections.ns2Sections.map(([value, label]) => (
            <option key={value} value={value}>{label as string}</option>
          ))}
        </optgroup>
        
        <optgroup label="Doppelklick NS3 (Der perfekte Coach)">
          {groupedSections.ns3Sections.map(([value, label]) => (
            <option key={value} value={value}>{label as string}</option>
          ))}
        </optgroup>

        <optgroup label="NS7 (Coaching Camps)">
          {groupedSections.ns7Sections.map(([value, label]) => (
            <option key={value} value={value}>{label as string}</option>
          ))}
        </optgroup>

        <optgroup label="Über Mich Bilder">
          {groupedSections.ns6Sections.map(([value, label]) => (
            <option key={value} value={value}>{label as string}</option>
          ))}
        </optgroup>
        
        <optgroup label="Metadaten Bilder">
          {groupedSections.metaSections.map(([value, label]) => (
            <option key={value} value={value}>{label as string}</option>
          ))}
        </optgroup>
        
        <optgroup label="Interne Referenzen (R1-R6)">
          {groupedSections.internalSections.map(([value, label]) => (
            <option key={value} value={value}>{label as string}</option>
          ))}
        </optgroup>
        
        <optgroup label="Legacy (zu entfernen)">
          {groupedSections.legacySections.map(([value, label]) => (
            <option key={value} value={value}>{label as string}</option>
          ))}
        </optgroup>
      </select>
    </div>
  );
};
